import { TRootState } from "../@types"

export const selectModalDirectoryCategories = ( state: TRootState ) =>state.directoryCategories.directoryCategoriesModalIsOpen

export const selectIsUpdateDirectoryCategories = ( state: TRootState ) =>state.directoryCategories.isUpdateDirectoryCategories

export const selectDirectoryCategoriesForUpdate = ( state: TRootState ) =>state.directoryCategories.directoryCategoriesForUpdate

export const selectDirectoryCategoriesRefreshTable =  ( state: TRootState ) =>state.directoryCategories.refreshTableDirectoryCategories
